/* unplugin-vue-components disabled */import __unplugin_components_7 from '~icons/ep/document-copy';
import { ElButton as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElTooltip as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/tooltip/style/css';
import { ElIcon as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_3 from '~icons/ep/edit-pen';
import { ElForm as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import __unplugin_components_0 from '/drone/src/packages/base/src/components/GameChannelSelect/index.vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0c9a119a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "icons-box"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 0,
  class: "icons-box"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 请先完成参数配置 ");
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 当前渠道无需在本平台配置支付方式 ");
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" - ");
const _hoisted_8 = /*#__PURE__*/_createTextVNode("配置");
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = /*#__PURE__*/_createTextVNode("商品管理 ");
const _hoisted_11 = /*#__PURE__*/_createTextVNode("配置");
const _hoisted_12 = {
  key: 1
};
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 当前渠道无需二次管理商品 ");
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" - ");
const _hoisted_15 = /*#__PURE__*/_createTextVNode("渠道回调地址 ");
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 当前渠道无需配置渠道回调地址 ");
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" - ");
const _hoisted_19 = /*#__PURE__*/_createTextVNode("渠道回调转发地址 ");
const _hoisted_20 = /*#__PURE__*/_createTextVNode("配置");
const _hoisted_21 = /*#__PURE__*/_createTextVNode("退款回调地址 ");
const _hoisted_22 = /*#__PURE__*/_createTextVNode("配置");
const _hoisted_23 = {
  key: 1
};
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 当前渠道不支持退款 ");
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" - ");
import { apiUsdkGetGlobalCallback, apiUsdkGoodsList, apuUsdkGetChannelOnlineConfig } from '@/api/usdk';
import { UseGlobalConfig } from '@/utils/hooks';
import { useAppStore } from '@/store/modules/app';
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { copyText } from '@ultra/share/utils';
import UseConfig from '../configHook';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const InternalPay = defineAsyncComponent(() => import('./internalPay.vue'));
    const GlobalPay = defineAsyncComponent(() => import('./globalPay.vue'));
    const CallbackUrl = defineAsyncComponent(() => import('./callbackUrl.vue'));
    const PayDesc = defineAsyncComponent(() => import('./payDesc.vue'));
    const InternalGoods = defineAsyncComponent(() => import('../goodsManage/internalGoods.vue'));
    const GlobalGoods = defineAsyncComponent(() => import('../goodsManage/globalGoods.vue'));
    const OtherCallbackUrl = defineAsyncComponent(() => import('./otherCallbackUrl.vue'));
    const {
      $channel
    } = UseGlobalConfig();
    const {
      payType
    } = UseConfig();
    const gameInfo = computed(() => useAppStore().gameInfo);
    const columns = [{
      label: '渠道ID',
      prop: 'cid'
    }, {
      label: '渠道名称',
      prop: 'name'
    }, {
      label: '支付管理',
      prop: 'pay',
      slot: 'pay'
    },
    // 隐藏支付说明配置 20230529 @博川
    // { label: '支付说明配置', prop: 'payDesc', slot: 'payDesc' },
    {
      label: '商品管理',
      prop: 'goods',
      slot: 'goods',
      header: 'goodsHeader'
    }, {
      label: '渠道回调地址',
      prop: 'channelCallbackUrl',
      slot: 'channelCallbackUrl',
      header: 'channelCbHeader'
    }, {
      label: '渠道回调转发地址',
      prop: 'otherCallbackUrl',
      slot: 'otherCallbackUrl',
      header: 'otherCbHeader'
    }, {
      label: '退款回调地址',
      prop: 'refundCallbackUrl',
      slot: 'refundCallbackUrl',
      header: 'refundCbHeader'
    }];
    const filter = reactive({
      cid: undefined,
      name: ''
    });
    const activeChannel = ref({});
    const activeCard = ref('payList');
    const payPanes = computed(() => {
      return [{
        title: '支付管理列表',
        key: 'payList'
      }, {
        title: `支付开关参数配置(${activeChannel.value.name})`,
        key: 'internalPay'
      }, {
        title: `支付开关参数配置(${activeChannel.value.name})`,
        key: 'globalPay'
      }, {
        title: `商品配置(${activeChannel.value.name})`,
        key: 'internalGoods'
      }, {
        title: `商品配置(${activeChannel.value.name})`,
        key: 'globalGoods'
      }];
    });
    const getTableData = () => {
      tableLoading.value = true;
      apuUsdkGetChannelOnlineConfig({
        gid: gameInfo.value.Id,
        ...filter
      }).then(res => {
        if (res.code === 0) {
          // this.list = res.data;
          const dict = ['internalPay', 'globalPay'];
          tableData.value = res.data.map(item => {
            dict.forEach(key => {
              item[key] = item[key] || {};
            });
            return item;
          });
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const {
      tableData,
      tableLoading
    } = UseTable(getTableData);
    const activeTable = computed(() => {
      if (!filter.cid) {
        return tableData.value;
      }
      return tableData.value.filter(item => item.cid === filter.cid);
    });
    // 获取全球退款回调地址
    const globalCallback = ref([]);
    const getGlobalCallback = gid => {
      apiUsdkGetGlobalCallback({
        gid
      }).then(res => {
        if (res.code === 0) {
          globalCallback.value = res.data;
        }
      });
    };
    // 获取商品列表
    const hasGoods = ref(false);
    const getGoodsList = gid => {
      apiUsdkGoodsList({
        Page: 1,
        pageSize: 10,
        gid
      }).then(res => {
        if (res.code === 0) {
          if (res.data.length) {
            hasGoods.value = true;
          }
        }
      });
    };
    watch(() => gameInfo.value.Id, val => {
      if (val) {
        activeCard.value = 'payList';
        getTableData();
        getGlobalCallback(val);
        getGoodsList(val);
      }
    }, {
      immediate: true
    });
    const payDesc = ref();
    const otherCallbackUrl = ref();
    const handleClick = (type, row) => {
      console.log('row---');
      console.log(row);
      activeChannel.value = row;
      if (type === 'set') {
        var _row$internalPay, _row$globalPay;
        if ((_row$internalPay = row.internalPay) !== null && _row$internalPay !== void 0 && _row$internalPay.usdkCid) {
          activeCard.value = 'internalPay';
        } else if ((_row$globalPay = row.globalPay) !== null && _row$globalPay !== void 0 && _row$globalPay.cid) {
          if (hasGoods.value) {
            activeCard.value = 'globalPay';
          } else {
            ElMessage.warning('请先配置商品档位!');
          }
        }
      } else if (type === 'desc') {
        var _payDesc$value;
        (_payDesc$value = payDesc.value) === null || _payDesc$value === void 0 ? void 0 : _payDesc$value.show(activeChannel.value);
      } else if (type === 'otherCallbackUrl') {
        var _otherCallbackUrl$val;
        (_otherCallbackUrl$val = otherCallbackUrl.value) === null || _otherCallbackUrl$val === void 0 ? void 0 : _otherCallbackUrl$val.show({
          cid: row.cid,
          url: row.otherCallbackUrl
        });
      }
    };
    // 商品配置
    const handleManageGoods = row => {
      activeChannel.value = row;
      if (hasGoods.value) {
        if ([$channel.GLOBAL_OFFICIAL_CHANNEL, $channel.GLOBAL_OFFICIAL_IOS_CHANNEL].includes(row.channel)) {
          activeCard.value = 'globalGoods';
        } else {
          activeCard.value = 'internalGoods';
        }
      } else {
        ElMessage.warning('请先配置商品档位!');
      }
    };
    const handleCopy = text => {
      copyText(text).then(() => {
        ElMessage.success('复制成功');
      });
    };
    // 退款回调地址
    const callbackUrl = ref();
    const handleCallback = row => {
      var _callbackUrl$value;
      let url = '';
      let isInternal = false;
      if ([$channel.OFFICIAL_CHANNEL, $channel.OFFICIAL_IOS_CHANNEL].includes(row.channel)) {
        url = row.refundCallbackUrl;
        isInternal = true;
      } else {
        let c = globalCallback.value.find(item => item.cid == row.cid);
        url = c && c.refundUrl || '';
      }
      (_callbackUrl$value = callbackUrl.value) === null || _callbackUrl$value === void 0 ? void 0 : _callbackUrl$value.show({
        url,
        cid: row.cid,
        isInternal
      });
    };
    return (_ctx, _cache) => {
      const _component_game_channel_select = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_form = __unplugin_components_2;
      const _component_i_ep_edit_pen = __unplugin_components_3;
      const _component_el_icon = __unplugin_components_4;
      const _component_el_tooltip = __unplugin_components_5;
      const _component_el_button = __unplugin_components_6;
      const _component_u_question = _resolveComponent("u-question");
      const _component_i_ep_document_copy = __unplugin_components_7;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_u_card, {
        modelValue: activeCard.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => activeCard.value = $event),
        panes: _unref(payPanes)
      }, {
        default: _withCtx(() => [_createVNode(_component_u_card_pane, {
          name: "payList"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            inline: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "选择渠道"
            }, {
              default: _withCtx(() => [_createVNode(_component_game_channel_select, {
                modelValue: _unref(filter).cid,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).cid = $event),
                gid: _unref(gameInfo).Id,
                clearable: ""
              }, null, 8, ["modelValue", "gid"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(UTable, {
            data: _unref(activeTable),
            loading: _unref(tableLoading),
            options: columns,
            pagination: "",
            "row-key": "cid"
          }, {
            pay: _withCtx(({
              scope
            }) => [scope.row.internalPay.usdkCid ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_unref(payType)(scope.row.internalPay).length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(payType)(scope.row.internalPay), (img, i) => {
              return _openBlock(), _createElementBlock("img", {
                key: i,
                src: img,
                alt: ""
              }, null, 8, _hoisted_2);
            }), 128))])) : _createCommentVNode("", true)], 64)) : [_unref($channel).GLOBAL_OFFICIAL_CHANNEL, _unref($channel).GLOBAL_OFFICIAL_IOS_CHANNEL].includes(scope.row.channel) ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [scope.row.globalPay.cid ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_unref(payType)(scope.row.globalPay, 'global').length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(payType)(scope.row.globalPay, 'global'), (img, i) => {
              return _openBlock(), _createElementBlock("img", {
                key: i,
                src: img,
                alt: ""
              }, null, 8, _hoisted_4);
            }), 128))])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 1
            }, {
              content: _withCtx(() => [_hoisted_5]),
              default: _withCtx(() => [_createVNode(_component_el_icon, {
                size: 16,
                class: "edit"
              }, {
                default: _withCtx(() => [_createVNode(_component_i_ep_edit_pen)]),
                _: 1
              })]),
              _: 1
            }))], 64)) : (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 2
            }, {
              content: _withCtx(() => [_hoisted_6]),
              default: _withCtx(() => [_hoisted_7]),
              _: 1
            })), scope.row.internalPay.usdkCid || scope.row.globalPay.cid ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 3,
              size: 16,
              class: "edit",
              onClick: $event => handleClick('set', scope.row)
            }, {
              default: _withCtx(() => [_createVNode(_component_i_ep_edit_pen)]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
            payDesc: _withCtx(({
              scope
            }) => [scope.row.internalPay.usdkCid ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              link: "",
              type: "primary",
              onClick: $event => handleClick('desc', scope.row)
            }, {
              default: _withCtx(() => [_hoisted_8]),
              _: 2
            }, 1032, ["onClick"])) : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))]),
            goodsHeader: _withCtx(() => [_createElementVNode("span", null, [_hoisted_10, _createVNode(_component_u_question, {
              content: "应三方支付渠道的规则要求，需要将渠道商品ID与游戏商品ID进行关联，以保证线上玩家正常购买商品。添加及编辑商品信息请前往“通用商品管理”"
            })])]),
            goods: _withCtx(({
              scope
            }) => [scope.row.needProduct == 1 ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              link: "",
              type: "primary",
              onClick: $event => handleManageGoods(scope.row)
            }, {
              default: _withCtx(() => [_hoisted_11]),
              _: 2
            }, 1032, ["onClick"])) : (_openBlock(), _createElementBlock("span", _hoisted_12, [_createVNode(_component_el_tooltip, null, {
              content: _withCtx(() => [_hoisted_13]),
              default: _withCtx(() => [_hoisted_14]),
              _: 1
            })]))]),
            channelCbHeader: _withCtx(() => [_createElementVNode("span", null, [_hoisted_15, _createVNode(_component_u_question, {
              content: "此地址自动生成，请将其配置在对应渠道后台，以保证支付到账；无此地址生成则无需配置"
            })])]),
            channelCallbackUrl: _withCtx(({
              scope
            }) => [scope.row.needCallbackUrl ? (_openBlock(), _createElementBlock("span", _hoisted_16, [_createVNode(_component_el_tooltip, null, {
              content: _withCtx(() => [_hoisted_17]),
              default: _withCtx(() => [_hoisted_18]),
              _: 1
            })])) : (_openBlock(), _createBlock(_component_el_icon, {
              key: 1,
              size: 16,
              class: "cp",
              color: "#3f6df8",
              onClick: $event => handleCopy(scope.row.channelCallbackUrl)
            }, {
              default: _withCtx(() => [_createVNode(_component_i_ep_document_copy)]),
              _: 2
            }, 1032, ["onClick"]))]),
            otherCbHeader: _withCtx(() => [_createElementVNode("span", null, [_hoisted_19, _createVNode(_component_u_question, {
              content: "此地址主要用于从别的渠道迁移到ULTRA使用，请将本页面上的【渠道回调地址】配置在对应的渠道后台，原有渠道后台配置的回调地址配置在此，用于保证线上已有渠道包和ULTRA出的渠道包在不强更的前提下都能支付并到账"
            })])]),
            otherCallbackUrl: _withCtx(({
              scope
            }) => [_createVNode(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => handleClick('otherCallbackUrl', scope.row)
            }, {
              default: _withCtx(() => [_hoisted_20]),
              _: 2
            }, 1032, ["onClick"])]),
            refundCbHeader: _withCtx(() => [_createElementVNode("span", null, [_hoisted_21, _createVNode(_component_u_question, {
              content: "当前仅App Store、Google Play支持退款。如渠道未单独配置，则使用通用回调地址接收退款通知"
            })])]),
            refundCallbackUrl: _withCtx(({
              scope
            }) => [[_unref($channel).OFFICIAL_IOS_CHANNEL, _unref($channel).GLOBAL_OFFICIAL_CHANNEL, _unref($channel).GLOBAL_OFFICIAL_IOS_CHANNEL].includes(scope.row.channel) ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              link: "",
              type: "primary",
              onClick: $event => handleCallback(scope.row)
            }, {
              default: _withCtx(() => [_hoisted_22]),
              _: 2
            }, 1032, ["onClick"])) : (_openBlock(), _createElementBlock("span", _hoisted_23, [_createVNode(_component_el_tooltip, null, {
              content: _withCtx(() => [_hoisted_24]),
              default: _withCtx(() => [_hoisted_25]),
              _: 1
            })]))]),
            _: 1
          }, 8, ["data", "loading"])]),
          _: 1
        }), _createVNode(_component_u_card_pane, {
          name: "internalPay"
        }, {
          default: _withCtx(() => [_createVNode(_unref(InternalPay), {
            channel: activeChannel.value,
            gid: _unref(gameInfo).Id,
            payParams: activeChannel.value.internalPay,
            onOk: getTableData
          }, null, 8, ["channel", "gid", "payParams"])]),
          _: 1
        }), _createVNode(_component_u_card_pane, {
          name: "globalPay"
        }, {
          default: _withCtx(() => [_createVNode(_unref(GlobalPay), {
            channel: activeChannel.value,
            gid: _unref(gameInfo).Id,
            payParams: activeChannel.value.globalPay,
            onOk: getTableData
          }, null, 8, ["channel", "gid", "payParams"])]),
          _: 1
        }), _createVNode(_component_u_card_pane, {
          name: "internalGoods"
        }, {
          default: _withCtx(() => [_createVNode(_unref(InternalGoods), {
            channel: activeChannel.value,
            gid: _unref(gameInfo).Id
          }, null, 8, ["channel", "gid"])]),
          _: 1
        }), _createVNode(_component_u_card_pane, {
          name: "globalGoods"
        }, {
          default: _withCtx(() => [_createVNode(_unref(GlobalGoods), {
            channel: activeChannel.value,
            gid: _unref(gameInfo).Id
          }, null, 8, ["channel", "gid"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "panes"]), _createVNode(_unref(CallbackUrl), {
        ref_key: "callbackUrl",
        ref: callbackUrl,
        gid: _unref(gameInfo).Id,
        onOk: getTableData
      }, null, 8, ["gid"]), _createVNode(_unref(PayDesc), {
        ref_key: "payDesc",
        ref: payDesc,
        channel: activeChannel.value,
        gid: _unref(gameInfo).Id
      }, null, 8, ["channel", "gid"]), _createVNode(_unref(OtherCallbackUrl), {
        ref_key: "otherCallbackUrl",
        ref: otherCallbackUrl,
        gid: _unref(gameInfo).Id,
        onOk: getTableData
      }, null, 8, ["gid"])], 64);
    };
  }
});